import DashboardNav from "./DashboardNav";
export default DashboardNav;